import React from 'react'
import { Box, Typography } from '@mui/material'


export default function providersNotAvailabilityColumn() {

	return {
		name: 'mainProviderNames',
		label: 'Providers not available',
		options: {
			setCellProps: () => ({
				sx: { maxWidth: 100 }
			}),
			customBodyRowRenderLite: value => <Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "start"
				}}>
				<Typography>{value?.join(', ')}</Typography>
			</Box>,
		}
	}
}
